// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  settlementId: __t.u64().primaryKey().name("settlement_id"),
  officeHex: __t.string().name("office_hex"),
  dailyInSov: __t.i64().name("daily_in_sov"),
  dailyOutSov: __t.i64().name("daily_out_sov"),
  dayBucket: __t.u32().name("day_bucket"),
  updatedAt: __t.timestamp().name("updated_at"),
});
